<template>
  <div class="card-container" @click="handleCardClick">
    <div v-if="editMode" class="delete-icon" @click.stop="handleDelete">
      <img src="@/assets/images/deleteMinusIcon.svg" alt="Delete" />
    </div>

    <div class="dashboard-card-wrapper">
      <div class="dashboard-card-header">
        <img :src="icon" alt="card icon" class="card-icon" />

      </div>

      <div class="dashboard-card-footer">
        <div class="footer-left">
          <div class="tag" :class="shortcut?.tagColor" v-if="shortcut?.tagColor && shortcut?.tagText && shortcut?.tagText !== ''">
            <span>{{ shortcut.tagText }}</span>
          </div>

          <div class="card-title">{{ shortcut.title }}</div>
        </div>

        <img src="@/assets/images/arrowRightFill.svg" width="20" height="20" />
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    shortcut: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    },
    icons: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {

    };
  },
  setup(props, { emit }) {
    const router = useRouter();

    const handleCardClick = () => {
      if (props.shortcut && !props.isDisabled && !props.editMode) {
        router.push(props.shortcut?.action);
      }
    };

    const handleDelete = () => {
      emit('delete', props.id);
    };

    return {
      handleCardClick,
      handleDelete
    };
  },
  computed: {
    icon() {
      return this.icons[this.shortcut.iconRef] || this.icons.addFill;
    }
  },
}
</script>

<style scoped>
.card-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  position: relative;
}


.card-title {
  font-size: 16px;
  font-family: euclid_medium, sans-serif;
  color: #344054;
  text-align: left;
}

.dashboard-card:hover + .card-title {
  color: #000;
}


.dashboard-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  transition: all 0.4s ease;
  border: 1px solid #EAECF0;
  cursor: pointer;
  position: relative;
  padding: 16px;
  aspect-ratio: 16/9;
}

.dashboard-card-wrapper:hover {
  background-color: #F5F5FF;
}

.dashboard-card-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}


.dashboard-card-footer {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
}

.footer-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
}

.delete-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #F04438;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  border: 2px solid white;
}

.delete-icon img {
  width: 14px;
  height: 14px;
}

.card-icon {
  width: 32px;
  height: 32px;
}


</style>
